import React from 'react';
import ReactDOM from 'react-dom/client';

import AppRoute from './routing';
import './index.less';
import reportWebVitals from './reportWebVitals';
import { getThemeName } from './utils/helpers';
import { I18nContextProvider } from './utils/I18n';
import { captureHostUrl, isEmbedded } from './utils/navigation';

import { notification } from 'antd';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
captureHostUrl();

// uncomment if you to hide the scroll bar and width
// if (isEmbedded()) {
//   document.documentElement.classList.add('is-embedded');
// }

// Configure notifications globally
notification.config({
  duration: 8,
  placement: 'topRight',
});

const themeName = getThemeName();
const auth = JSON.parse(localStorage.getItem('trips_auth')) || {};
document.documentElement.style.setProperty('--primary-color', `${auth?.ExtraData?.PrimaryColor || '#EC9832'}`);

root.render(
  <I18nContextProvider>
    <div className="theme-default" id="app-container">
      <AppRoute />
    </div>
  </I18nContextProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
